import { createSelector } from 'reselect'

const selectorFactory = (countriesSelector, geolocationDataSelector) =>
  createSelector(countriesSelector, geolocationDataSelector, (countries, geolocation) => {
    const countryCode = geolocation?.countryCode
    const country = countries[countryCode]

    if (!country) {
      return {}
    }

    const isBuySupported = Object.values(country.providers || {}).some(
      (provider) => provider.isBuySupported
    )
    const isSellSupported = Object.values(country.providers || {}).some(
      (provider) => provider.isSellSupported
    )

    return {
      code: country.code,
      name: country.name,
      providers: country.providers,
      isBuySupported,
      isSellSupported,
      isSupported: isBuySupported || isSellSupported,
    }
  })

const countrySelectorDefinition = {
  id: 'country',
  selectorFactory,
  dependencies: [
    //
    { selector: 'countryData' },
    { module: 'geolocation', selector: 'data' },
  ],
}

export default countrySelectorDefinition
